import { redirectTo, RouteComponentProps } from '@reach/router';
import { isAbsolute, join } from 'path-browserify';
import React from 'react';
import { defined } from 'utils/defined';

interface Props extends RouteComponentProps {
    to: string;
}

/**
 * Reach router's redirect implementation doesn't work with relative paths for some reason.
 * This does.
 */
export function BetterRedirect(props: Props) {
    const { location, to } = props;
    const destination = isAbsolute(to) ? to : join(defined(location).pathname, to);
    redirectTo(destination);
    return <></>;
}
